import { render, staticRenderFns } from "./ProductoLiquidoExport.vue?vue&type=template&id=547f5520"
import script from "./ProductoLiquidoExport.vue?vue&type=script&lang=js"
export * from "./ProductoLiquidoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports